import { ProcedureType } from "./procedure-type";


export class ProcedureCategory {
  public id?: number;
  public procedureTypeID?: number | null;
  public procedureType?: ProcedureType | null;
  public name?: string;
}
